export default __webpack_public_path__ + "locales/sl/Article.json?hash=76f3941e2d2039516db517426726468a";